
<app-admin-side-bar></app-admin-side-bar>

  <!-- Navbar -->
  <nav class="main-header navbar navbar-expand navbar-dark">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" appRemoveOverlayDirective data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Home</a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <a class="nav-link">Discount Templates</a>
      </li>
    </ul>
  
    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- <li class="nav-item dropdown">
        <a><app-admin-test-mode></app-admin-test-mode> </a>
      </li> -->
    </ul>
  </nav>
  <!-- /.navbar -->


<div class="content-wrapper">

  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Discount Templates</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Discount Templates</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <div class="container-fluid"  style="padding: 15px;">
    
    <div class="row ">
      <section class="col-md-3">
        <!-- <button class="popup-button" mat-button (click)="openCreateModal()">Add-Country</button> -->
        <button type="button" (click)="openCreateModal()" class="btn btn-primary">
          Add Discount Template
        </button>

      </section>
      <section class="col-md-6">
      
      </section>
     <section class="col-md-3" style="float: right;">
       <input type="text" #keyword placeholder="Search"> &nbsp;
       <button class="btnDef" (click)="Filter(keyword.value)">Search</button>
      </section>
      <section class="col-md-12 mt-2">

        <div class="card">
        
          <!-- /.card-header -->
          <div class="card-body">
            <div class="row">
              <div class="col-5"></div>
              <div class="col-2">
                <div *ngIf="loader==true">
                  <app-loader style="text-align: center;"></app-loader>
                </div>
              </div>
              <div class="col-5"></div>
            </div>

            <table *ngIf="loader==false" id="example2" class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Name</th>
                  <th>General Discount</th>
                  <th>Customized Discount</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody *ngFor="let discount of countries; let i = index;">
                <tr>
                  <td>{{discount.id}}</td>
                  <td>{{discount.name}}</td>
                  <td><a class="link" (click)="CreateGeneralDiscount(discount.id)">Edit</a> </td>
                  <td><a class="link" (click)="CustomizedDiscountTemplate(discount.id)">Edit</a> </td>
                  <td>
                    <i class="fa fa-pen" style="font-size: 13px;" (click)="Edit(discount.id)"></i> &nbsp;&nbsp;&nbsp;
                    <i class="fa fa-trash" style="font-size: 13px;" (click)="Delete(discount.id)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-center my-3" *ngIf="totalItems > 0">
            <app-pager [totalCount]="totalItems" [pageSize]="10" (pageChanged)="onPageChanged($event)"></app-pager>
          </div>
          
          <!-- /.card-body -->
        </div>

      </section>
    </div>
  </div>

  
</div>

  <!-- Main Footer -->
  